import * as React from 'react';
import { connect } from 'react-redux';

import { executePromiseAction } from '../../actions/loadingActions';
import { isEmpty } from '../../utils/generalUtils';

export interface IAsyncProps extends IAsyncStoreProps {
    promise: (...args: any[]) => any;
    identifier: string;
    loader: JSX.Element | JSX.Element[];
    content: JSX.Element | JSX.Element[];
    error: JSX.Element | JSX.Element[];
    initialState?: IAsyncState;
}

export interface IAsyncStoreProps {
    executePromise?: () => void;
    loadingState?: IAsyncState | any;
}

export interface IAsyncState {
    isLoading?: boolean;
    hasError?: boolean;
}

export class AsyncImpl extends React.Component<IAsyncProps, {}> {

    public static defaultProps = {
        loadingState: {
            isLoading: false,
            hasError: false
        }
    };

    public executePromise = () => {
        const { identifier, promise } = this.props;
        if (promise instanceof Function) {
            executePromiseAction(
                promise(),
                identifier
            );
        }
    }

    public componentWillMount() {
        this.executePromise();
    }

    public renderChildren = () => {
        const { content, loader, error, identifier, loadingState } = this.props;
        const { isLoading, hasError } = loadingState;
        if ((isLoading || isEmpty(loadingState)) && loader) {
            return (loader);
        }

        if (!isLoading && !hasError) {
            return (content);
        }

        if (hasError && Error) {
            return (error);
        }
        return null;
    }

    public render() {
        return this.renderChildren();
    }
}

export function mapStateToProps(state, ownProps) {
    return {
        loadingState: state.loading.get(ownProps.identifier) || ownProps.initialState || {}
    };
}

export const Async = connect<{}, {}, IAsyncProps>(mapStateToProps)(AsyncImpl as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/Async.tsx